module.exports = __webpack_public_path__ + "img/bg.5365cbeb.jpg";